/*=========================================================================================
  File Name: moduleVariablesState.js
  Description: Calendar Module State
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
  symptoms: [],
  default_symptoms: [],
  all_symptoms: [],

  risk_factors: [],
  default_risk_factors: [],
  all_risk_factors: [],

  tbi_localization: [],
  default_tbi_localization: [],

  side_effects: [],
  default_side_effects: [],

  laboratory_monitoring: [],
  default_laboratory_monitoring: [],

}
